import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { Label } from '@radix-ui/react-label';
import baseLabelStyles from './BaseLabel.styles.esm.js';

/**
 * The BaseLabel component builds a label and should not be used directly but instead
 * composed with othe Base components to build more complex components
 */
const BaseLabel = (_a) => {
    var { className = "", disabled = false, inverse = false, variant = "default", error } = _a, otherProps = __rest(_a, ["className", "disabled", "inverse", "variant", "error"]);
    const classes = baseLabelStyles({
        inverse,
        variant,
        class: className,
    });
    return (jsx(Label, Object.assign({ className: classes, "aria-disabled": disabled }, otherProps)));
};
BaseLabel.displayName = "BaseLabel";

export { BaseLabel };
